module.exports = __webpack_public_path__ + "img/for-you05.00d0678d.jpg";